import React from "react";
import {
  AbsoluteFill,
  interpolate,
  interpolateColors,
  useCurrentFrame,
} from "remotion";
import ProjectCard from "../components/ProjectCard";
import { SceneHeading } from "../components/SceneChrome";
import { projectById } from "../data/resume";
import { PALO_BEAT_LENGTH, PALO_DECK_CARD_IDS } from "../data/scenes";
import firstRescueDemo from "../../../images/firstRescueDemo.gif";

// Scene 3 — Palo deck (22–45%): 5 cards dealt one per beat. The active card
// holds center stage; spent cards shrink into a pile along the bottom.
const Scene3PaloDeck: React.FC = () => {
  const frame = useCurrentFrame();
  const beat = PALO_BEAT_LENGTH;
  const projects = PALO_DECK_CARD_IDS.map(projectById);

  const beatStarts = projects.map((_, i) => i * beat);
  const tint = interpolateColors(
    frame,
    beatStarts.length > 1 ? beatStarts : [0, 1],
    projects.map((p) => p.color)
  );

  return (
    <AbsoluteFill style={{ backgroundColor: "#181818" }}>
      <AbsoluteFill
        style={{
          backgroundImage: `radial-gradient(ellipse at 50% 45%, ${tint}50 0%, ${tint}14 45%, transparent 75%)`,
        }}
      />
      <SceneHeading
        title="Palo IT — Typescript Fullstack Engineer"
        subtitle="2020–2023 · 5 clients, 5 industries"
        color={tint}
        enterFrame={2}
      />
      {projects.map((project, i) => {
        const enterFrame = beatStarts[i] + 6;
        const retireFrame = beatStarts[i] + beat; // when the next card takes the stage
        const isLast = i === projects.length - 1;
        const Icon = project.icon;

        // Center stage → pile slot along the bottom-left.
        const pileX = -700 + i * 180;
        const stageProgress = isLast
          ? 0
          : interpolate(frame, [retireFrame, retireFrame + 14], [0, 1], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            });

        return (
          <AbsoluteFill
            key={project.id}
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 70,
              translate: `${stageProgress * pileX}px ${stageProgress * 330}px`,
              scale: String(1 - stageProgress * 0.72),
              opacity: interpolate(
                frame,
                [retireFrame + 40, retireFrame + 70],
                [1, 0.55],
                { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
              ),
            }}
          >
            <ProjectCard
              title={project.title}
              client={project.client}
              color={project.color}
              bullets={project.bullets}
              stack={project.stack}
              size="deck"
              enterFrame={enterFrame}
              flipFrame={beatStarts[i] + beat - 12}
              icon={<Icon sx={{ fontSize: 52 }} />}
            >
              {project.id === "firstrescue" ? (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={firstRescueDemo}
                    alt="First Rescue demo"
                    style={{
                      height: 170,
                      borderRadius: 12,
                      border: `2px solid ${project.color}66`,
                    }}
                  />
                  <div
                    style={{
                      fontFamily: "'JetBrains Mono', monospace",
                      fontSize: 20,
                      color: project.color,
                      marginTop: 8,
                    }}
                  >
                    /showcase/firstrescue →
                  </div>
                </div>
              ) : null}
            </ProjectCard>
          </AbsoluteFill>
        );
      })}
    </AbsoluteFill>
  );
};

export default Scene3PaloDeck;
